import {
  EditReferencesMutationTypes,
  LockModel,
  ErrorModel,
  DocumentToStoreModel,
  DocumentToStoreViewModel,
  SchemaModel,
  KeyValuePair,
  Cabinet,
  ExistingDocumentOption,
  PagesStoreMode,
  EditReferencesState
} from '@/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<EditReferencesState> = {
  [EditReferencesMutationTypes.SetIsLoading](state, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  [EditReferencesMutationTypes.SetIsDirty](state, isDirty: boolean) {
    state.isDirty = isDirty;
  },
  [EditReferencesMutationTypes.SetIsReadonly](state, isReadonly: boolean) {
    state.isReadonly = isReadonly;
  },
  [EditReferencesMutationTypes.SetExtendingDocumentLock](state, payload: boolean) {
    state.extendingDocumentToStoreLock = payload;
  },
  [EditReferencesMutationTypes.ExtendDocumentLock](state, payload: LockModel) {
    state.documentToStore.lock = payload;
  },
  [EditReferencesMutationTypes.ExpireDocumentLock](state, payload: any) {
    if (payload) {
      state.errorMessage = payload;
    }
    state.documentToStore.lock = {} as LockModel;
  },
  [EditReferencesMutationTypes.DocumentToStoreLoaded](state, payload: DocumentToStoreModel) {
    state.documentToStore = payload;
    state.isLoading = false;
    state.error = false;
  },
  [EditReferencesMutationTypes.DocumentToStoreError](state, payload: any) {
    state.errorMessage = JSON.stringify(payload);
    state.documentToStore = {} as DocumentToStoreModel;
    state.isLoading = false;
    state.error = true;
  },
  [EditReferencesMutationTypes.SetComponentName](state, componentName: string) {
    state.documentToStore.componentName = componentName;
  },
  [EditReferencesMutationTypes.SetErrorModel](state, errorModel: ErrorModel) {
    state.documentToStore.errorModel = errorModel;
  },
  [EditReferencesMutationTypes.SetDocumentToStoreView](state, payload: DocumentToStoreViewModel) {
    state.documentToStoreView = payload;
    state.initialSchema = payload.dynamicFormSchema.map((model) => {
      return { ...model };
    });
  },
  [EditReferencesMutationTypes.SetDynamicFormSchema](state, payload: SchemaModel[]) {
    state.documentToStoreView.dynamicFormSchema = payload;
  },
  [EditReferencesMutationTypes.SetMultiValueReferenceValues](state, payload: any[]) {
    state.documentToStoreView.multiValueReferences = payload;
  },
  [EditReferencesMutationTypes.SetSchemaValueFromReference](state, reference: KeyValuePair<string>) {
    const stateSchema = state.documentToStoreView.dynamicFormSchema.find((schema) => schema.id.toLowerCase() === reference.key.toLowerCase());
    if (stateSchema) {
      stateSchema.value = reference.value;
    }
  },
  [EditReferencesMutationTypes.SetDocumentDateValue](state, documentDate: Date | null) {
    const documentDateSchema = state.documentToStoreView.dynamicFormSchema.find((schema) => schema.id.toLowerCase() === Cabinet.DocumentDateReference.FieldKey.toLowerCase());
    if (documentDateSchema) {
      documentDateSchema.value = documentDate;
    }
  },
  [EditReferencesMutationTypes.SetSourceDocumentTypeId](state, documentTypeId: number) {
    state.selectedSourceDocumentTypeId = documentTypeId;
  },
  [EditReferencesMutationTypes.SetTargetDocumentTypeId](state, documentTypeId: number) {
    state.targetDocumentTypeId = Number(documentTypeId);
  },
  [EditReferencesMutationTypes.SetExistingDocumentId](state, documentId: number) {
    state.existingDocumentId = documentId;
  },
  [EditReferencesMutationTypes.SetExistingDocumentOption](state, option: ExistingDocumentOption) {
    state.existingDocumentOption = option;
  },
  [EditReferencesMutationTypes.SetInitialSchemaValues](state, { initialSchema, initialDocumentDate }) {
    state.initialSchema = initialSchema.map((model: SchemaModel) => {
      return { ...model };
    });
    state.initialDocumentDate = initialDocumentDate;
  },
  [EditReferencesMutationTypes.SetInitialMultiValueReferences](state, initialMultiValues: any[]) {
    state.initialMultiValueReferences = initialMultiValues;
  },
  [EditReferencesMutationTypes.SetSelectedPages](state, value: string) {
    state.selectedPages = value;
  },
  [EditReferencesMutationTypes.SetPagesStoreMode](state, value: PagesStoreMode) {
    state.pagesStoreMode = value;
  },
  [EditReferencesMutationTypes.SetPageViewedBeforeAddToExisting](state, page: number) {
    state.pageViewedBeforeAddToExisting = page;
  }
};
